import { auth } from '@monorepo/utils/firebase'
import { sendPasswordResetEmail as sendPasswordResetEmailFirebase } from '@monorepo/utils/firebase'

export const sendPasswordResetEmail = async (payload: { email: string }) => {
  await sendPasswordResetEmailFirebase(auth(), payload.email)
}
